import { Component, ReactElement } from 'react';
import { FormattedMessage } from 'react-intl';
import { Link } from 'react-router-dom';
import { PoolButton } from '@synergy/components';
import { Theme } from '@mui/material';
import { WithStyles, createStyles, withStyles } from '@mui/styles';
import { getUrlSegment } from '@synergy/utils';

import { ActivityObjectClass } from '../../../common/models/activity';
import { TransitionActivity } from '../../../common/models/transition-activity';
import { geDocumentTypeFromString } from '../../../common/utils/get-document-type-from-string';
import { getDocumentTranslationId } from '../../../common/utils/get-document-name-translation-id';

const styles = (theme: Theme) =>
    createStyles({
        link: {
            textDecoration: 'none',
            color: '#fff',
            '& button': {
                borderRadius: '3rem',
                marginRight: theme.spacing(),
            },
        },
    });

interface ConvertReceiptTransitionsItemProps extends WithStyles<typeof styles> {
    transitionActivity: TransitionActivity;
}
class ConvertReceiptTransitionsItemBase extends Component<ConvertReceiptTransitionsItemProps> {
    private getNumberSpan = (): ReactElement => {
        const { transitionActivity } = this.props;

        if (transitionActivity.toType === ActivityObjectClass.Invoice) {
            return transitionActivity.toNumber ? (
                <>&nbsp;#{transitionActivity.toNumber}</>
            ) : (
                <>
                    -<FormattedMessage id="app.convertReceipt.draft" />
                </>
            );
        }

        return <>&nbsp;#{transitionActivity.toId}</>;
    };

    public render() {
        const { classes, transitionActivity } = this.props;

        const documentType = geDocumentTypeFromString(transitionActivity.toType);
        const url = `/${getUrlSegment(documentType)}/${this.props.transitionActivity.toId}`;

        return (
            <Link to={url} className={classes.link}>
                <PoolButton styleType="firstLevel">
                    <span>
                        <FormattedMessage id={getDocumentTranslationId(documentType)} />
                        {this.getNumberSpan()}
                    </span>
                </PoolButton>
            </Link>
        );
    }
}

export const ConvertReceiptTransitionsItem = withStyles(styles)(ConvertReceiptTransitionsItemBase);
